import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Cashless_Balance_Report.css";
import userImg from "../../images/user.png";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { FaSearch } from "react-icons/fa";
import { formatNumber } from "../../utils/formatNumber";

function Cashless_Balance_Report() {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchAdmission, setSearchAdmission] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        admission_number_search: searchAdmission,
        student_search: searchTerm,
        dropdown: "true",
      };

      const response = await simplePostCall(
        ApiConfig.cashlessWalletreporteports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setReportData(response.data || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, searchAdmission]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleClearFilters = () => {
    setSearchTerm("");
    setSearchAdmission("");
  };

  return (
    <div className="cashless_balance_report-container fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Cashless Balance Report</h4>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <input
            type="text"
            placeholder="Search Student"
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Search Admission"
            className="form-control"
            value={searchAdmission}
            onChange={(e) => setSearchAdmission(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-6">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Image</div>
            <div className="yc-list-cell">Student</div>
            <div className="yc-list-cell">Admission Number</div>
            <div className="yc-list-cell">Grade</div>
            <div className="yc-list-cell">Amount</div>
          </div>
        </div>

        {/* Rows */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : reportData.length > 0 ? (
          <div className="yc-list-row-list">
            {reportData.map((item, index) => (
              <div key={item.student_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-6">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">
                    <img
                      src={item.student_profilepicture || userImg}
                      width="35"
                      height="35"
                      alt="User"
                      className="wallet-main-img"
                      onError={(e) => { e.target.src = userImg; }}
                    />
                  </div>
                  <div className="yc-list-cell">{item.student_name}</div>
                  <div className="yc-list-cell">{item.student_admission_num}</div>
                  <div className="yc-list-cell">{item.grade || "N/A"}</div>
                  <div className="yc-list-cell yc-amount-positive">
                    {formatNumber(item.wallet_amount)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No records found.</div>
        )}
      </div>
    </div>
  );
}

export default Cashless_Balance_Report;
